export default "__VITE_ASSET__DSsWSBOe__"